<script>
import { mapState } from 'vuex';
import GalleryBanner from '../../components/galleryBanner.vue';
import GalleryInfo from '../../components/galleryInfo.vue';

export default {
    name: "galleryHome",
    data() {
        return {
            swiperOptions: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView: 3,
                spaceBetween: '4.1667%',
            },
            swiperOptions2: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                // slidesPerView: 3,
                // spaceBetween: '4.1667%',
            },
        };
    },
    computed: {
        ...mapState(['galleryHome']),
    },
    components: {
        GalleryBanner,
        GalleryInfo
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="gallery_home">
        <!-- banner -->
        <GalleryBanner :data="galleryHome.banner"/>
        <!--  -->
        <div class="content_group">
            <div class="content" v-if="galleryHome.news.length > 0">
                <div class="layout_main">
                    <div class="title">最新消息</div>
                    <swiper class="list type1 only_pc" :options="swiperOptions">
                        <swiper-slide v-for="(item, index) in galleryHome.news" :key="index">
                            <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                            <p class="time">{{ item.start_time }}</p>
                            <p class="name">{{ item.name }}</p>
                            <p class="link"><router-link :to="`/gallery/latestNews/detail?id=${item.id}`">了解更多</router-link></p>
                        </swiper-slide>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                    <div class="only_mobile">
                        <div class="m_list type1 flex flex_column">
                            <div class="item" v-for="(item, index) in galleryHome.news" :key="index">
                                <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                                <div class="text">
                                    <p class="time">{{ item.start_time }}</p>
                                    <p class="name">{{ item.name }}</p>
                                    <p class="link"><router-link :to="`/gallery/latestNews/detail?id=${item.id}`">了解更多</router-link></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify_end">
                        <router-link class="btn_more flex align_center" to="/gallery/latestNews">更多消息</router-link>
                    </div>
                </div>
            </div>
            <div class="content" v-if="galleryHome.exhibition.length > 0">
                <div class="layout_main">
                    <div class="title">展览</div>
                    <!-- pc -->
                    <swiper class="list type2 only_pc" :options="swiperOptions">
                        <swiper-slide v-for="(item, index) in galleryHome.exhibition" :key="index">
                            <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                            <p class="name">{{ item.name }}</p>
                            <div class="time flex align_center">
                                <img :src="require('@/assets/images/icon_calendar.png')" alt="" class="icon calendar"/>
                                <p>{{ item.start_time }} - {{ item.end_time }}</p>
                            </div>
                            <div class="price flex align_center">
                                <img :src="require('@/assets/images/icon_price.png')" alt="" class="icon price"/>
                                <p v-if="item.price == '0.00'">免费</p>
                                <p v-else>RMB {{ item.price }}</p>
                            </div>
                            <p class="link"><router-link :to="`/gallery/exhibition/detail?id=${item.id}`">了解更多</router-link></p>
                        </swiper-slide>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                    <!-- mobile -->
                    <swiper class="list type2 only_mobile" :options="swiperOptions2">
                        <swiper-slide v-for="(item, index) in galleryHome.exhibition" :key="index">
                            <router-link :to="`/gallery/exhibition/detail?id=${item.id}`">
                                <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                                <p class="name">{{ item.name }}</p>
                                <div class="time flex align_center">
                                    <img :src="require('@/assets/images/icon_calendar.png')" alt="" class="icon calendar"/>
                                    <p>{{ item.start_time }} - {{ item.end_time }}</p>
                                </div>
                                <div class="price flex align_center">
                                    <img :src="require('@/assets/images/icon_price.png')" alt="" class="icon price"/>
                                    <p v-if="item.price == '0.00'">免费</p>
                                    <p v-else>RMB {{ item.price }}</p>
                                </div>
                            </router-link>
                            <!-- <p class="link"><router-link :to="`/gallery/exhibition/detail?id=${item.id}`">了解更多</router-link></p> -->
                        </swiper-slide>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                    <div class="flex justify_end">
                        <router-link class="btn_more flex align_center" to="/gallery/exhibition">更多展览</router-link>
                    </div>
                </div>
            </div>
            <div class="content" v-if="galleryHome.works.length > 0">
                <div class="layout_main">
                    <div class="title">作品</div>
                    <!-- pc -->
                    <swiper class="list type3 big_cover only_pc" :options="swiperOptions">
                        <swiper-slide v-for="(item, index) in galleryHome.works" :key="index">
                            <router-link :to="`/gallery/works/detail?id=${item.id}`">
                                <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                                <p class="name">{{ item.artist_name }}</p>
                                <p class="desc">{{ item.name }}</p>
                            </router-link>
                        </swiper-slide>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                    <!-- mobile -->
                    <swiper class="list type3 big_cover only_mobile" :options="swiperOptions2">
                        <swiper-slide v-for="(item, index) in galleryHome.works" :key="index">
                            <router-link :to="`/gallery/works/detail?id=${item.id}`">
                                <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                                <p class="name">{{ item.artist_name }}</p>
                                <p class="desc">{{ item.name }}</p>
                            </router-link>
                        </swiper-slide>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                    <div class="flex justify_end">
                        <router-link class="btn_more last flex align_center" to="/gallery/works">更多优秀作品</router-link>
                    </div>
                </div>
            </div>
            <div class="content" v-if="galleryHome.activity.length > 0">
                <div class="layout_main">
                    <div class="title">跨界活动</div>
                    <!-- pc -->
                    <swiper class="list type2 big_cover only_pc" :options="swiperOptions">
                        <swiper-slide v-for="(item, index) in galleryHome.activity" :key="index">
                            <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                            <p class="name">{{ item.name }}</p>
                            <div class="time flex align_center">
                                <img :src="require('@/assets/images/icon_calendar.png')" alt="" class="icon calendar"/>
                                <p>{{ item.start_time }} - {{ item.end_time }}</p>
                            </div>
                            <div class="price flex align_center">
                                <img :src="require('@/assets/images/icon_price.png')" alt="" class="icon price"/>
                                <p v-if="item.price == '0.00'">免费</p>
                                <p v-else>RMB {{ item.price }}</p>
                            </div>
                            <p class="link"><router-link :to="`/gallery/activities/detail?id=${item.id}`">了解更多</router-link></p>
                        </swiper-slide>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                    <!-- mobile -->
                    <swiper class="list type2 big_cover only_mobile" :options="swiperOptions2">
                        <swiper-slide v-for="(item, index) in galleryHome.activity" :key="index">
                            <router-link :to="`/gallery/activities/detail?id=${item.id}`">
                                <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                                <p class="name">{{ item.name }}</p>
                                <div class="time flex align_center">
                                    <img :src="require('@/assets/images/icon_calendar.png')" alt="" class="icon calendar"/>
                                    <p>{{ item.start_time }} - {{ item.end_time }}</p>
                                </div>
                                <div class="price flex align_center">
                                    <img :src="require('@/assets/images/icon_price.png')" alt="" class="icon price"/>
                                    <p v-if="item.price == '0.00'">免费</p>
                                    <p v-else>RMB {{ item.price }}</p>
                                </div>
                            </router-link>
                            <!-- <p class="link"><router-link :to="`/gallery/activities/detail?id=${item.id}`">了解更多</router-link></p> -->
                        </swiper-slide>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                    <div class="flex justify_end">
                        <router-link class="btn_more last flex align_center" to="/gallery/activities">更多活动</router-link>
                    </div>
                </div>
            </div>
        </div>
        <GalleryInfo/>
    </div>
</template>

<style scoped lang="scss">
.content{
    border-bottom: 1px solid #999;
    padding: .5rem 0;
    &:last-child{
        border-bottom: none;
    }
    .title{
        font-size: .25rem;
        text-align: center;
        font-weight: bold;
        margin-bottom: .3rem;
        @media only screen and (max-width: 750px) {
            font-size: .36rem;
            margin-bottom: .5rem;
        }
    }
    .swiper-container{
        --swiper-navigation-color: #999;/* 单独设置按钮颜色 */
        --swiper-navigation-size: .25rem;/* 设置按钮大小 */
        .swiper-button-prev,
        .swiper-button-next{
            top: 50%;
            margin-top: 0;
            transform: translate(0, -50%);
            padding: .2rem;
            &.swiper-button-disabled{
                opacity: 0;
            }
        }
        .swiper-button-prev{
            left: 0;
        }
        .swiper-button-next{
            right: 0;
        }
        @media only screen and (max-width: 750px) {
            width: 7.5rem;
            margin: 0 -.3rem;
            .swiper-slide{
                padding: 0 .3rem;
            }
            .swiper-button-prev,
            .swiper-button-next{
                padding: .15rem;
            }
        }
    }
    .btn_more{
        font-size: .18rem;
        color: #666;
        margin: .3rem .4rem .3rem 0;
        cursor: pointer;
        &::after{
            content: "";
            display: block;
            width: .1rem;
            height: .1rem;
            border-top: 1px solid #666;
            border-right: 1px solid #666;
            transform: rotate(45deg);
            margin-left: .05rem;
        }
        &.last{
            margin-bottom: 0;
        }
        @media only screen and (max-width: 750px) {
            font-size: .22rem;
            margin: .4rem auto 0;
            color: #999;
            &::after{
                display: none;
            }
        }
    }
    .list{
        padding: 0 .4rem;
        @media only screen and (max-width: 750px) {
            padding: 0;
        }
        .swiper-button-prev,
        .swiper-button-next{
            top: 1.43rem;
        }
        .cover{
            height: 0;
            padding-bottom: 84.12%;
            margin-bottom: .2rem;
            // 
            // border: 1px solid #000;
            
            @media only screen and (max-width: 750px) {
                height: 4.5rem;
                padding: 0;
                margin-bottom: .3rem;
            }
        }
        .link{
            font-size: .18rem;
            text-align: center;
            color: #666;
            margin-top: .3rem;
            a{
                border-bottom: 1px solid #666;
            }
        }
        &.type1{
            .time{
                font-size: .18rem;
                margin-bottom: .1rem;
            }
            .name{
                font-size: .2rem;
            }
        }
        &.type2{
            .name{
                font-size: .2rem;
                font-weight: bold;
                margin-bottom: .1rem;
            }
            .time,
            .price{
                font-size: .2rem;
                color: #666;
            }
            .time{
                margin-bottom: .1rem;
            }
            .icon{
                margin-right: .1rem;
                &.calendar{
                    width: .21rem;
                }
                &.price{
                    width: .24rem;
                }
                @media only screen and (max-width: 750px) {
                    &.calendar{
                        width: .29rem;
                    }
                    &.price{
                        width: .32rem;
                    }
                }
            }
            @media only screen and (max-width: 750px) {
                text-align: center;
                .name{
                    font-size: .28rem;
                    margin-bottom: .2rem;
                }
                .time,
                .price{
                    font-size: .26rem;
                    justify-content: center;
                }
            }
        }
        &.big_cover{
            .cover{
                padding-bottom: 139.41%;
                @media only screen and (max-width: 750px) {
                    height: 8.5rem;
                    padding: 0;
                }
            }
            .swiper-button-prev,
            .swiper-button-next{
                top: 2.42rem;
            }
        }
        &.type3{
            text-align: center;
            font-size: .2rem;
            line-height: 2;
            @media only screen and (max-width: 750px) {
                font-size: .28rem;
            }
        }
    }
    .m_list{
        color: #fff;
        gap: .3rem;
        .item{
            position: relative;
            .cover{
                height: 4.5rem;
            }
            .text{
                background: linear-gradient(to bottom, rgba($color: #000000, $alpha: 0), rgba($color: #000000, $alpha: .8));
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                padding: .5rem 0;
                text-align: center;
                .name,
                .time{
                    font-size: .28rem;
                    margin-bottom: .1rem;
                }
                .name{
                    margin-bottom: .2rem;
                }
                .link{
                    font-size: .22rem;
                }
            }
        }
    }
}
</style>